import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { EventForm } from './EventForm';
import { eventService, PostType } from '../../../services/eventService';
import { openMessageModal } from '../../../components/statusModal/messageModalActionCreators';
import { PanelRow } from '../../../components/panel/PanelRow';
import { Panel } from '../../../components/panel/Panel';

export const EventCreate = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();

  // Get post type from query params, default to 'event'
  const queryParams = new URLSearchParams(location.search);
  const postType = (queryParams.get('type') as PostType) || 'event';

  const handleSubmit = async (data: any) => {
    const contentType = postType === 'event' ? 'Event' : 'Article';
    try {
      await eventService.createEvent(data);
      dispatch(openMessageModal(`${contentType} created successfully`, 'success'));
      history.push('/admin/content');
    } catch (error) {
      console.error(`Failed to create ${contentType.toLowerCase()}:`, error);
      dispatch(openMessageModal(`Failed to create ${contentType.toLowerCase()}`, 'error'));
      throw error;
    }
  };

  const handleCancel = () => {
    history.push('/admin/content');
  };

  return (
    <PanelRow fluid>
      <Panel noPadding>
        <EventForm postType={postType} onSubmit={handleSubmit} onCancel={handleCancel} isEdit={false} />
      </Panel>
    </PanelRow>
  );
};
